const KEY = "speedy_attribution";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "matchtype", "device", "sport", "for", "gclid", "gbraid", "wbraid"];

export const captureAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  FIELDS.forEach((k) => { const v = params.get(k); if (v) found[k] = v.slice(0, 200); });
  if (!Object.keys(found).length) return;
  found.landing_path = window.location.pathname;
  found.captured_at = new Date().toISOString();
  if (document.referrer) found.referrer = document.referrer.slice(0, 300);
  sessionStorage.setItem(KEY, JSON.stringify(found));
};

export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch { return null; }
};
